/**
 * /settings/users: the shared launchpad Users page on its own, for direct
 * links (the Manage dialog's Users tab is the in-app entry). Without
 * VITE_ENABLE_USERS_SETTINGS or a `darwin` / `redactit_admin` token role it
 * redirects to the cases list before mounting, so nothing is requested.
 */

import { Navigate, useNavigate } from 'react-router-dom';
import { ArrowLeft, Users } from 'lucide-react';
import { IconTooltip } from '../components/ui/tooltip';
import { UsersSettingsPanel } from '../components/management/UsersSettingsPanel';
import { useCanManageUsersSettings } from '../lib/usersSettings';

export function UsersSettingsPage() {
  const navigate = useNavigate();
  const allowed = useCanManageUsersSettings();
  if (!allowed) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-white">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center gap-4">
          <IconTooltip label="Back to cases">
            <button
              onClick={() => navigate('/')}
              className="p-2 hover:bg-muted rounded-lg transition-colors"
              aria-label="Back"
            >
              <ArrowLeft className="w-5 h-5 text-foreground" />
            </button>
          </IconTooltip>
          <div className="flex items-center gap-2">
            <Users className="w-5 h-5 text-[#7035C4]" />
            <h1 className="text-lg font-semibold">Users</h1>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-8">
        <UsersSettingsPanel />
      </main>
    </div>
  );
}
